/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Panel                       from 'g3w-panel';
import ApplicationState            from 'g3w-state'
import GUI                         from 'g3w-app';
import { createFilterFromString }  from 'utils/createFilterFromString';
import { getCatalogLayerById }     from 'utils/getCatalogLayerById';

import G3WTool                     from 'components/Tool.vue';
import vueComp                     from 'components/QueryBuilder.vue';
import { gettext as _ }            from 'g3w-i18n';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'search',

  data() {
    return {
      state: this.state || {},
    };
  },

  components: {
    'g3w-tool': G3WTool,
  },

  methods: {
    /**@since 4.1.0  ORIGINAL SOURCE: src/g3w-app.js@v4.0.0*/
    showQueyBuilderPanel() {
      GUI.closeContent();
      GUI.closeSideBar();
      return new Panel({
        title: _('Advanced search'),
        show: true,
        vueComponentObject: vueComp
      });
    },

    showPanel(config = {}) {
      this.$options.service.showPanel(config);
    },

    /**
     * ORIGINAL SOURCE: src/services/querybuilder.js@v3.9.3
     */
    async remove(search, index) {
      const ok = await GUI.confirm(_('Do you want delete it?'));

      if (!ok) {
        return;
      }

      const item     = window.localStorage.getItem('QUERYBUILDERSEARCHES');
      const items    = item ? JSON.parse(item) : undefined;
      const pid      = ApplicationState.project.getId();
      const searches = (items ? items[pid] || [] : []).filter(item => search.id !== item.id);

      if (searches.length) {
        items[pid] = searches;
      } else {
        delete items[pid];
      }

      try {
        if (Object.keys(items).length) {
          window.localStorage.setItem('QUERYBUILDERSEARCHES', JSON.stringify(items));
        } else {
          window.localStorage.removeItem('QUERYBUILDERSEARCHES');
        }
      } catch(e) {
        console.warn(e);
      }

      this.state.querybuildersearches.splice(index, 1); // remove item
    },

    edit(search) {
      const opts = {
        id:            search.id,
        name:          search.name,
        layerId:       search.layerId,
        filter:        search.filter,
        title:         _('Advanced search'),
        show:          true,
      };
      opts.internalPanel = new (Vue.extend(vueComp))({ options: opts });
      new Panel(opts);
    },

    /**
     * ORIGINAL SOURCE: src/services/querybuilder.js@v3.9.3
     */
    async run(search) {
      search.qbloading = true;
      try {
        const layer = getCatalogLayerById(search.layerId);
        await GUI.getData('search:features', {
          inputs: {
            layer,
            filter: createFilterFromString({ layer, filter: search.filter }),
            feature_count: 100,
          },
          outputs: true,
        });
      } catch(e) {
        console.warn(e);
        GUI.showUserMessage({ type: 'alert', message: 'An error occurs. Please check the query', autoclose: true });
      }
      search.qbloading = false;
    },

  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"treeview-menu g3w-search g3w-tools menu-items",attrs:{"id":"g3w-search"}},[_vm._l((_vm.state.searches),function(search){return _c('li',{staticClass:"menu-item",attrs:{"role":"button","tabindex":"0"},on:{"click":function($event){return _vm.showPanel(search)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.showPanel(search)}}},[_c('i',{staticClass:"far fa-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.name))])])}),_vm._v(" "),_vm._l((_vm.state.tools),function(searchtool){return _c('li',[_c('g3w-tool',{attrs:{"tool":searchtool}})],1)}),_vm._v(" "),_vm._l((_vm.state.querybuildersearches),function(search,i){return _c('li',{key:search.id},[_c('div',{staticStyle:{"position":"relative"},on:{"click":function($event){return _vm.edit(search)}}},[_c('bar-loader',{attrs:{"loading":search.qbloading}}),_vm._v(" "),_c('div',{staticClass:"search-tools"},[_c('button',{staticClass:"fas fa-trash",staticStyle:{"color":"red","margin-right":"5px"},attrs:{"type":"button","title":"Delete","data-placement":"bottom"},on:{"click":function($event){$event.stopPropagation();return _vm.remove(search, i)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.name))]),_vm._v(" "),_c('button',{staticClass:"fas fa-play",staticStyle:{"color":"green","margin-left":"auto"},attrs:{"type":"button","title":"Run","data-placement":"bottom"},on:{"click":function($event){$event.stopPropagation();return _vm.run(search)}}})])],1)])}),_vm._v(" "),_c('li',{staticClass:"menu-item",attrs:{"role":"button","tabindex":"0"},on:{"click":function($event){$event.stopPropagation();return _vm.showQueyBuilderPanel.apply(null, arguments)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.showQueyBuilderPanel.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-calculator",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('Advanced search'),expression:"'Advanced search'"}]})])],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3500a5f2_0", { source: "li.menu-item[data-v-3500a5f2]{padding-right:20px!important}li.menu-item span[data-v-3500a5f2]{display:inline-flex;white-space:pre-wrap}#g3w-search li i[data-v-3500a5f2]{width:20px}.search-tools[data-v-3500a5f2]{display:flex;align-items:baseline}.search-tools>span[data-v-3500a5f2]{white-space:pre-wrap}.search-tools>button[data-v-3500a5f2]{text-shadow:0 2px 5px rgba(0,0,0,.3);padding:0 4px;border:none;background-color:unset}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-3500a5f2"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Search.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__